import {AppLoginProps} from 'appmodule/login/App'
import {log} from 'common/log'
import {createRoot} from 'react-dom/client'
import React from 'react'

export function initLogin(AppModule: AppLoginProps) {
	const {App, rootElementId} = AppModule;
	const container = document.getElementById(rootElementId)
	if (container) {
		const root = createRoot(container);
		root.render(<App/>);
	} else {
		log.error('missing react root container - `{}`', rootElementId)
	}
}